import React from "react";
import { connect } from "react-redux";
import * as agent from "../agent";
import { getFormValues, reduxForm, Field } from "redux-form";
import { DenialReasons } from "../constants/enums";
import { MaterialTextField, MaterialCheckbox } from "./MaterialInput";
import { CLIENT_LOADED } from "../constants/actionTypes";
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const { managerReasons, clientReasons } = DenialReasons;

class loanDenied extends React.Component {
    state = {
        value: 0
    };

    switchTab = (e, value) => this.setState({ value });

    render() {
        const { value } = this.state;
        const { car, formValues = {}, onDenyLoan, onDuplicateClient, handleSubmit } = this.props;
        const { _id, loan: { denialReasons = [], denialSource } = {} } = car;
        const prepareData = (data, i) => {
            const s = ["MANAGER", "CLIENT"][i];
            return Object.assign(
                {},
                {"denialSource": s},
                {"denialReasons": []
                    .concat(s === "MANAGER" ? Object.keys(managerReasons).reduce((p, n) => p.concat(data[n] ? n : []), []) : [])
                    .concat(data.customReason ? [data.customReason] : [] )
                    .concat(s === "CLIENT" ? Object.keys(clientReasons).reduce((p, n) => p.concat(data[n] ? n : []), []) : [])
                }
            );
        };

        const enabled = value === 0 ?
            Object.keys(formValues).some(v => formValues[v] && managerReasons[v]) || formValues.customReason :
            Object.keys(formValues).some(v => formValues[v] && clientReasons[v] || formValues.customReason);

        return (
            <Paper className="welcome-paper">
                {(denialSource && denialReasons.length > 0) ?
                    <React.Fragment>
                    <Typography variant="h5" gutterBottom>Займ закрыт</Typography>
                    <Typography variant="h5" gutterBottom>{"Источник: "+({"CLIENT": "Клиент", "MANAGER": "Менеджер"}[denialSource])}</Typography>
                    <Typography variant="h5" gutterBottom>Причины:</Typography>
                    {denialReasons.map((r, i) => (
                        <Typography gutterBottom>- {(denialSource === "MANAGER" ? managerReasons[r] : clientReasons[r]) || r}</Typography>
                    ))}
                    <Button type="submit"
                            fullWidth
                            onClick={() => onDuplicateClient(car)}
                            size="large"
                            color="primary"
                            variant="contained" >Открыть займ</Button>
                    </React.Fragment>
                    :
                    <form className="common-form" onSubmit={handleSubmit(data => onDenyLoan(_id, prepareData(data, value)))}>
                        <Typography variant="h5" gutterBottom>Причина отказа</Typography>
                        <Tabs value={value} onChange={this.switchTab} centered >
                            <Tab label="Менеджер" />
                            <Tab label="Клиент" />
                        </Tabs>
                        <SwipeableViews axis='x' index={value}>
                            <div dir="x" className="tab">
                                {Object.keys(managerReasons).map((r, i) => (
                                     <FormControlLabel key={i} control={<Field name={r} component={MaterialCheckbox} /> } label={managerReasons[r]} />
                                 ))}
                                <Field component={MaterialTextField}
                                       name="customReason"
                                       label="Другое" />
                            </div>
                            <div dir="x" className="tab">
                                {Object.keys(clientReasons).map((r, i) => (
                                    <FormControlLabel key={i} control={<Field name={r} component={MaterialCheckbox} /> } label={clientReasons[r]} />
                                ))}
                                <Field component={MaterialTextField}
                                       name="customReason"
                                       label="Другое" />
                            </div>
                        </SwipeableViews>
                        <Button type="submit"
                                disabled={!enabled}
                                fullWidth
                                size="large"
                                color="primary"
                                variant="contained" >Отказать</Button>
                    </form>
                }
            </Paper>
        )
    }
}

const LoanDenied = connect(
    state => {
        return {
            formValues: getFormValues("deny-form")(state),
        };
    },
    dispatch => ({
        onDenyLoan: (id, details) =>
            agent.Clients.denyLoan(id, details)
            .then(client => dispatch({type: CLIENT_LOADED, payload: client})),
    })
)(reduxForm({ form:"deny-form" })(loanDenied));

export default LoanDenied;



// WEBPACK FOOTER //
// ./src/components/LoanDenied.js